<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="类别" prop="type">
                <a-select v-model="queryParam.type" placeholder="请选择类别" allow-clear>
                  <a-select-option :value="1">免费申领</a-select-option>
                  <a-select-option :value="2">预购/再领一本	</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="是否三方" prop="isThirty">
                <a-select v-model="queryParam.isThirty" placeholder="请选择是否三方" allow-clear>
                  <a-select-option :value="1">是</a-select-option>
                  <a-select-option :value="0">否</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="是否顺丰到付" prop="isSfCod">
                <a-select v-model="queryParam.isSfCod" placeholder="请选择是否顺丰到付" allow-clear>
                  <a-select-option :value="1">是</a-select-option>
                  <a-select-option :value="0">否</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24" v-if="queryParam.isThirty">
              <a-form-item label="是否已发优惠券" prop="isIssueCoupons">
                <a-select v-model="queryParam.isIssueCoupons" placeholder="请选择是否已发优惠券" allow-clear>
                  <a-select-option :value="1">是</a-select-option>
                  <a-select-option :value="0">否</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24" v-if="!queryParam.isThirty">
              <a-form-item label="状态" prop="status">
                <a-select v-model="queryParam.status" placeholder="请选择类别" allow-clear>
                  <a-select-option :value="10">申领审核中</a-select-option>
                  <a-select-option :value="11">申领任务通过</a-select-option>
                  <a-select-option :value="12">申领未通过</a-select-option>
                  <a-select-option :value="20">发货审核中</a-select-option>
                  <a-select-option :value="21">发货任务通过(待发货)</a-select-option>
                  <a-select-option :value="22">发货未通过</a-select-option>
                  <a-select-option :value="40">未激活</a-select-option>
                  <a-select-option :value="99">已完成</a-select-option>
                  <a-select-option :value="-1">已过期</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="店铺名称" prop="shopName">
                <a-input v-model="queryParam.shopName" placeholder="请输入店铺名称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24" v-if="this.username !== 'played'">
              <a-form-item label="剧本名称" prop="scriptId">
                <a-select
                  show-search
                  placeholder="请选择剧本"
                  v-model="queryParam.scriptId"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  allow-clear
                >
                  <a-select-option v-for="(item) in this.playedScriptList" :value="item.scriptId" :key="item.scriptId">
                    {{ item.scriptName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="快递编号" prop="shippingNumber">
                <a-input v-model="queryParam.shippingNumber" placeholder="请输入快递编号" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="收货省市区" prop="city">
                <a-cascader
                  v-model="selectedCityValue"
                  :options="cityList"
                  change-on-select
                  @change="onCityChange"
                  placeholder="请选择省市区"
                  v-if="cityList"
                />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="创建日期" prop="createTime">
                <a-date-picker style="width: 100%" @change="onCreateDateChange" format="YYYY-MM-DD" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24" style="float: right">
              <span class="table-page-search-submitButtons" :style="{ float: 'right', overflow: 'hidden' }">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
                <!--                  {{ advanced ? '收起' : '展开' }}-->
                <!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
                <!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['played:script/apply:add']">-->
        <!--          <a-icon type="plus" />新增-->
        <!--        </a-button>-->
        <!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['played:script/apply:edit']">-->
        <!--          <a-icon type="edit" />修改-->
        <!--        </a-button>-->
                <a-button type="danger" :disabled="multiple" @click="openDelReasonModal" v-hasPermi="['played:script/apply:remove']">
                  <a-icon type="delete" />删除
                </a-button>
        <!--        <a-button type="primary" @click="handleExport" v-hasPermi="['played:script/apply:export']">-->
        <!--          <a-icon type="download" />导出-->
        <!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :class="list.length === 0? 'emptyTable' : ''"
      >
        <span slot="status" slot-scope="text, record">
          <!-- 重写自定义了个字典组件（标签）-->
          <span v-if="record.isThirty">已完成(三方)</span>
          <custom-dict-tag :options="customDict.PlayedScriptApplyStatusEnum" :value="record.status" v-if="!record.isThirty" />
        </span>
        <!--        <span slot="shippingTime" slot-scope="text, record">-->
        <!--          {{ parseTime(record.shippingTime) }}-->
        <!--        </span>-->
        <!--        <span slot="expectedShippingMissionDate" slot-scope="text, record">-->
        <!--          {{ parseTime(record.expectedShippingMissionDate) }}-->
        <!--        </span>-->
        <!--        <span slot="activateTime" slot-scope="text, record">-->
        <!--          {{ parseTime(record.activateTime) }}-->
        <!--        </span>-->
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['played:script/apply:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['played:script/apply:remove']" v-if="record.isThirty && !record.isIssueCoupons" />
          <a @click="handleIssueCoupons(record.id)" v-hasPermi="['played:script/apply:remove']" v-if="record.isThirty && !record.isIssueCoupons" >
            <a-icon type="edit" />发优惠券
          </a>
          <!--          <a-divider type="vertical" v-hasPermi="['played:script/apply:remove']" />-->
          <!--          <a @click="handleDelete(record)" v-hasPermi="['played:script/apply:remove']">-->
          <!--            <a-icon type="delete" />删除-->
          <!--          </a>-->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        :page-size-options="pageSizeOptions"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>

    <a-modal
      ref="issueCouponsRef"
      title="发放优惠券"
      :width="500"
      :visible="issueCouponsModal"
      class="issue-coupon"
      @ok="btnIssueCoupons"
      @cancel="closeModal"
    >
      <a-form-model-item label="只发测本券">
        <a-switch v-model="onlyTestCoupon" />
      </a-form-model-item>
      <a-form-model-item label="预购券数量" v-if="!onlyTestCoupon">
        <a-input-number
          v-model="couponsNumber"
          style="width: 100%"
          :min="0"
          :max="99"
          :precision="0"
          placeholder="请输入预购券数量"
        />
      </a-form-model-item>
    </a-modal>

    <a-modal
      ref="delReason"
      title="删除原因"
      :width="500"
      :visible="delReasonModal"
      @ok="handleDelete"
      @cancel="delReasonModal = false"
    >
      <a-form-model-item>
        <a-input
          v-model="delReason"
          style="width: 100%"
          placeholder="删除原因"
        />
      </a-form-model-item>
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import { listScriptApply, delPlayedScriptApply } from '@/api/played/scriptApply'
import { issueThirtyCoupons } from '@/api/played/shopCoupon'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import CustomDictTag from '@/components/DictCustomTag/index.vue'
import { mapGetters } from 'vuex'
import { convertToCascaderFormat } from '@/utils/areaDataConverter'
import { Cascader } from 'ant-design-vue'
import { listScript } from '@/api/played/script'

export default {
  name: 'ScriptApply',
  components: {
    CustomDictTag,
    CreateForm,
    'a-cascader': Cascader
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      playedScriptList: [],
      selectedCityValue: [], // 用于绑定 cascader 的值
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        shopName: undefined,
        scriptId: undefined,
        scriptName: undefined,
        type: undefined,
        shippingNumber: undefined,
        isThirty: undefined,
        isSfCod: null,
        isIssueCoupons: undefined,
        shippingStatus: null,
        status: undefined,
        areap: undefined,
        areac: undefined,
        areax: undefined,
        createTime: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          width: 60,
          ellipsis: true,
          align: 'center',
          fixed: 'left',
          customRender: (text, record, index) => index + 1
        },
        // {
        //   title: '主键id',
        //   dataIndex: 'id',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '类别',
          dataIndex: 'type',
          ellipsis: true,
          align: 'center',
          width: 120,
          fixed: 'left',
          customRender: (text) => {
            return { 1: '免费申领', 2: '预购/再领一本' }[text]
          }
        },
        {
          title: '店铺名称',
          dataIndex: 'shopName',
          ellipsis: true,
          width: 120,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '剧本名称',
          dataIndex: 'scriptName',
          ellipsis: true,
          width: 120,
          align: 'center'
        },
        {
          title: '下单价格',
          dataIndex: 'orderPrices',
          ellipsis: true,
          width: 90,
          align: 'center'
        },
        {
          title: '预购车数量',
          dataIndex: 'preOrderCarNum',
          ellipsis: true,
          width: 90,
          align: 'center'
        },
        {
          title: '省',
          dataIndex: 'province',
          ellipsis: true,
          width: 100,
          align: 'center'
        },
        {
          title: '市',
          dataIndex: 'city',
          ellipsis: true,
          width: 100,
          align: 'center'
        },
        // {
        //   title: '区',
        //   dataIndex: 'district',
        //   ellipsis: true,
        //   width: 100,
        //   align: 'center'
        // },
        {
          title: '快递编号',
          dataIndex: 'shippingNumber',
          ellipsis: true,
          width: 130,
          align: 'center'
        },
        {
          title: '发货时间',
          dataIndex: 'shippingTime',
          scopedSlots: { customRender: 'shippingTime' },
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        // {
        //   title: '预计发货任务日期',
        //   dataIndex: 'expectedShippingMissionDate',
        //   scopedSlots: { customRender: 'expectedShippingMissionDate' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '激活时间',
        //   dataIndex: 'activateTime',
        //   scopedSlots: { customRender: 'activateTime' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '配送状态',
          dataIndex: 'shippingStatus',
          ellipsis: true,
          align: 'center',
          width: 80,
          customRender: (text) => {
            return { 1: '待发货', 2: '运输中', 3: '派件中', 4: '已签收', 5: '未知' }[text]
          }
        },
        {
          title: '状态',
          dataIndex: 'status',
          ellipsis: true,
          scopedSlots: { customRender: 'status' },
          width: 130,
          align: 'center'
        },
        {
          title: '是否已发优惠券',
          dataIndex: 'isIssueCoupons',
          ellipsis: true,
          width: 130,
          align: 'center',
          customRender: (text, record) => {
            if (record.isThirty) {
              return { false: '否', true: '是' }[text]
              // return <span>{record.submitTime == null ? record.createTime : record.submitTime}</span>
            } else {
              return null
            }
          }
        },
        {
          title: '是否顺丰到付',
          dataIndex: 'isSfCod',
          ellipsis: true,
          align: 'center',
          width: 120,
          customRender: (text) => {
            return { false: '否', true: '是' }[text]
          }
        },
        {
          title: '发货备注',
          dataIndex: 'remarkNoteTwo',
          ellipsis: true,
          width: 180,
          align: 'center'
        },
        {
          title: '申领备注',
          dataIndex: 'remarkNoteOne',
          ellipsis: true,
          width: 180,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          width: 145,
          align: 'center'
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          ellipsis: true,
          width: 145,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 170,
          scopedSlots: { customRender: 'operation' },
          align: 'center',
          fixed: 'right'
        }
      ],
      issueCouponsModal: false,
      delReasonModal: false,
      delReason: undefined,
      // 选中的申领id
      issueApplyId: null,
      onlyTestCoupon: false,
      couponsNumber: 0,
      username: null,
      pageSizeOptions: ['10', '20', '30', '40', '50', '100', '200', '300']
    }
  },
  filters: {
  },
  created () {
    this.username = this.$store.state.user.name
    this.getList()
    if (this.username !== 'played') {
      listScript({ scriptName: this.queryParam.scriptName }).then(res => {
        this.playedScriptList = res.data
      })
    }
  },
  computed: {
    ...mapGetters(['customDict']),
    cityList () {
      const rawData = this.$store.state.user.cityList
      if (rawData && rawData.length > 0) {
        return convertToCascaderFormat(rawData)
      }
      return []
    }
  },
  watch: {
  },
  methods: {
    openDelReasonModal () {
      this.delReasonModal = true
      this.delReason = undefined
    },
    /** 查询银河打本剧本申领列表 */
    getList () {
      this.loading = true
      if (this.username === 'played') {
        this.queryParam.scriptId = '600366524552953856'
      }
      listScriptApply(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    onCreateDateChange (date, dateString) {
      this.queryParam.createTime = dateString
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        shopName: undefined,
        scriptId: undefined,
        scriptName: undefined,
        type: undefined,
        shippingNumber: undefined,
        isThirty: undefined,
        isSfCod: null,
        isIssueCoupons: undefined,
        shippingStatus: null,
        status: undefined,
        areap: undefined,
        areac: undefined,
        areax: undefined,
        createTime: null,
        pageNum: 1,
        pageSize: 10
      }
      // 清空 cascader 选中的值
      this.selectedCityValue = []
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    handleDelete (row) {
      if (!this.delReason) {
        this.$message.error(
          '删除原因不能为空',
          3
        )
        return
      }
      var that = this
      const ids = row.id || this.ids
      this.$confirm({
        title: `确认删除选中的${ids.length}条数据?`,
        onOk () {
          return delPlayedScriptApply({ idList: ids, remark: that.delReason })
            .then(() => {
              that.delReasonModal = false
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {}
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('played/script/apply/export', {
            ...that.queryParam
          }, `script/apply_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    handleIssueCoupons(applyId) {
      this.issueApplyId = applyId
      this.issueCouponsModal = true
    },
    btnIssueCoupons () {
      if (this.couponsNumber == null || (!this.onlyTestCoupon && this.couponsNumber === 0)) {
        this.$message.warning('请输入正确数量进行发放！')
      } else if (!this.onlyTestCoupon && this.couponsNumber > 3) {
        const that = this
        this.$confirm({
          title: '确认发放' + this.couponsNumber + '张优惠券?',
          content: '此发放操作不可逆，请再次确认！',
          onOk() {
            const data = {
              applyId: this.issueApplyId,
              onlyTestCoupon: this.onlyTestCoupon,
              couponsNumber: this.onlyTestCoupon ? 0 : this.couponsNumber
            }
            issueThirtyCoupons(data).then(res => {
              this.$message.success(
                '发放优惠券成功',
                3
              )
              that.closeModal()
              that.getList()
            })
          },
          onCancel() {
            that.closeModal()
          }
        })
      } else {
        const data = {
          applyId: this.issueApplyId,
          couponsNumber: this.onlyTestCoupon ? 0 : this.couponsNumber
        }
        issueThirtyCoupons(data).then(res => {
          this.$message.success(
            '发放优惠券成功',
            3
          )
          this.closeModal()
          this.getList()
        })
      }
    },
    // 关闭模态框
    closeModal () {
      this.issueCouponsModal = false
      this.onlyTestCoupon = false
      this.couponsNumber = 0
    },
    onCityChange(value) {
      this.queryParam.areap = undefined
      this.queryParam.areac = undefined
      this.queryParam.areax = undefined
      if (value) {
        if (value.length > 0) {
          this.queryParam.areap = value[0]
        }
        if (value.length > 1) {
          this.queryParam.areac = value[1]
        }
        if (value.length > 2) {
          this.queryParam.areax = value[2]
        }
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    }
  }
}
</script>
<style scoped>
.issue-coupon .ant-modal-body .ant-form-item {
  margin-bottom: 0;
}
.issue-coupon .ant-modal-body .ant-form-item-label {
  line-height: 18px;
}
</style>
